require('babel-polyfill');
const Raven = require('raven-js');
const config = require('./config');

export function setup() {
  if (config.env === 'production') {
    Raven.config(config.sentryDsn).install();
  }
}
